import { withTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { Component, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { c as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Label } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';

class Counter extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "incrementCount", () => {
      const {
        max,
        step
      } = this.props;
      if (max !== undefined) {
        if (this.state.count >= max) {
          return;
        }
      }
      this.setState(state => {
        const incrementStep = step !== undefined ? step : 1;
        return {
          count: state.count + incrementStep
        };
      });
    });
    _defineProperty(this, "decrementCount", () => {
      const {
        min,
        step
      } = this.props;
      if (min !== undefined) {
        if (this.state.count <= min) {
          return;
        }
      }
      this.setState(state => {
        const decrementStep = step !== undefined ? step : 1;
        return {
          count: state.count - decrementStep
        };
      });
    });
    this.state = {
      count: 0
    };
  }
  componentDidUpdate(_, prevState) {
    if (this.state.count !== prevState.count && typeof this.props.onCountChange === 'function') {
      this.props.onCountChange(this.state.count);
    }
  }
  render() {
    const {
      onDecrement = this.decrementCount,
      onIncrement = this.incrementCount,
      count = this.state.count,
      label,
      styles,
      min,
      max,
      disabled,
      theme
    } = this.props;
    return /*#__PURE__*/createElement(Div, _extends({
      display: "flex",
      alignItems: "center",
      width: "auto"
    }, styles.root), /*#__PURE__*/createElement(Button, {
      iconOnly: true,
      iconProps: {
        glyph: icons.REMOVE
      },
      onClick: onDecrement,
      disabled: min !== undefined ? count <= min : disabled || false,
      shape: "circle",
      small: true,
      variant: "tertiary",
      testId: "decrementButton"
    }), /*#__PURE__*/createElement(Div, {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      p: `0 ${theme.spacing.sm}px`
    }, /*#__PURE__*/createElement(Label, _extends({}, theme.typography.label, {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.fontSizeSmall
    }, styles.label), label), /*#__PURE__*/createElement(Div, null, count)), /*#__PURE__*/createElement(Button, {
      iconOnly: true,
      iconProps: {
        glyph: icons.ADD
      },
      onClick: onIncrement,
      disabled: max !== undefined ? count >= max : disabled || false,
      shape: "circle",
      small: true,
      variant: "tertiary",
      testId: "incrementButton"
    }));
  }
}
_defineProperty(Counter, "defaultProps", {
  disabled: false,
  styles: {}
});
var Counter$1 = withTheme(Counter);

export default Counter$1;
